import en from './locale/en';
import pt_BR from './locale/pt_BR';

export const eagerMessages = { en, pt_BR };

export async function loadLocale(i18n, locale) {
  if (!locale || i18n.availableLocales.includes(locale)) return;
  const { default: messages } = await import(`./locale/${locale}/index.js`);
  i18n.setLocaleMessage(locale, messages);
}

// navigator.language uses hyphens ('pt-BR'); App uses underscores ('pt_BR').
// Only these four have regional variants; all others use 2-letter codes.
export function normalizeBrowserLocale(lang) {
  if (!lang) return null;
  return lang.replace('-', '_');
}

export default eagerMessages;
